export default __webpack_public_path__ + "static/media/consult.3809570d.svg";